import React, { Component } from 'react';
import Menu from './Menu';

export default function Layout(props) {

	return (
		<div id="main_content">
			<Menu {...props} />
		</div>
	);

}
